// @flow

import experiments from 'app/common/lib/experiments';
import type { LocaleData } from 'app/packages/pinterest-flow-types/i18n';

type CopytuneExperiments = {
  translations: { [string]: string },
  triggerable: { [string]: string },
};

export default function augmentLocaleData(
  localeData: LocaleData,
  enablePseudoloc: boolean,
  copytuneExperiments: ?CopytuneExperiments,
): Promise<Object> {
  const inPseudolocExperiment = experiments.getInstance().v2InGroup('pseudoloc', 'enabled');
  const inContextTranslationExperiment = experiments
    .getInstance()
    .v2InGroup('inContextTranslation', 'enabled');

  if (inPseudolocExperiment && enablePseudoloc) {
    return import('app/common/lib/pseudoLocalize').then((module) => ({
      ...localeData,
      pseudoLocalize: module.default(inPseudolocExperiment),
    }));
  } else if (inContextTranslationExperiment) {
    return import('app/packages/pinterest-l10n/InContextTranslation').then((module) => {
      const InContextTranslation = module.default;
      return {
        ...localeData,
        inContextTranslationWebapp: new InContextTranslation('webapp'),
        copytuneExperiments,
        experiments: experiments.getInstance(),
      };
    });
  } else {
    return Promise.resolve({
      ...localeData,
      copytuneExperiments,
      experiments: experiments.getInstance(),
    });
  }
}
